export function vytvorBublinyModal() {
  Lc.f("vytovrBublinyModal");

  try {
    let data = window.sortimentDoplnky.Buglist || false;
    if (!data) throw new Error("Nenalezeny hodnoty");

    $("a[data-oknoplus]").click(function() {
      let a = $(this);
      let b = a.data("oknoplus") || false;
      if (!b || !b.length) throw new Error("Nenalezena data pro bublinu");

      let html = data[b] || false;
      if (!html || !html.length) throw new Error("Nenalezeno html pro bublinu");
      $(`<div>${html}</div>`).modal();
    });
  } catch (error) {
    Lc.err(error);
  }
}
